"use strict";function setScreenKeepOn$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setScreenKeepOn$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.setScreenKeepOn";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.26"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.26"},_a)),exports.setScreenKeepOn$=setScreenKeepOn$,exports.default=setScreenKeepOn$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/setScreenKeepOn.js
// module id = 1026
// module chunks = 106